<template>
    <div class="send-rate-form">
        <div class="send-rate-form__text">Выберите эмоцию</div>
        <div class="d-flex justify-space-between align-end mb-10">
            <div class="send-rate-ants">
                <div class="send-rate-ants__buttons">
                    <img
                        src="/images/rates/ants/bad_full.svg"
                        @click="
                            new_rate.progress_line = 6
                            new_rate.rate = 1
                        "
                    />
                    <img
                        src="/images/rates/ants/good_full.svg"
                        @click="
                            new_rate.progress_line = 50
                            new_rate.rate = 2
                        "
                    />
                    <img
                        src="/images/rates/ants/cool_full.svg"
                        @click="
                            new_rate.progress_line = 100
                            new_rate.rate = 3
                        "
                    />
                </div>
               
                <v-progress-linear
                    class="send-rate-ants__loader"
                    :value="new_rate.progress_line"
                    background-color="#E9E9E9"
                    color="#F1915A"
                ></v-progress-linear>
            </div>
            
        </div>
        <template v-if="new_rate.rate && new_rate.to">
            <div class="send-rate-form__text ">Оставьте отзыв</div>
            <textarea placeholder="Идейные соображения…" v-model="new_rate.comment" class="mb-10"></textarea>
            <CreateRate :new_rate="new_rate" @close_modal="on_close_modal"  @before_send="on_before_send"></CreateRate>
        </template>
    </div>
</template>

<script>
import CreateRate from './../CreateRate.vue'

import { mapGetters } from 'vuex'

export default {
    name: 'NewDepartmentRate',
    data: () => ({
        group: false,
        group_name: null,
        new_rat: {
            comment: '',
            progress_line: 0,
            from: localStorage.getItem('_id'),
            to: '',
            rate: 0,
            date: new Date().toISOString().substring(0, 10),
        },
    }),
    props: ['dialog', 'department', 'new_rate'],
    components: {
        CreateRate,
    },

    computed: {
        ...mapGetters(['get_rates']),
    },
    methods: {
        on_close_modal(value) {
            this.$emit('close_modal', value)
        },
        on_before_send(value) {
            this.$emit('before_send', value)
        },
        get_percent(rates, type) {
            let x = []

            switch (type) {
                case 'low':
                    x = rates.filter((rate) => rate.rate == '1')
                    break
                case 'middle':
                    x = rates.filter((rate) => rate.rate == '2')
                    break
                case 'high':
                    x = rates.filter((rate) => rate.rate == '3')
                    break

                default:
                    break
            }

            if (x.length == 0) return `0 %`
            return ` ${((x.length / rates.length) * 100).toFixed()} %`
        },
    },
}
</script>

<style scoped>
.send-rate-form {
    margin-top: 40px;
}

.send-rate-form__text {
    font-weight: bold;
    font-size: 18px;
    line-height: 18px;
    color: #1f0303;
    margin-bottom: 20px;
    text-align: center;
}

.send-rate-form textarea {
    height: 175px;
    background: #f8f8f8;
    border-radius: 30px;
    width: 100%;
    padding: 20px;
    resize: none;
}

* {
    margin: 0 auto;
}
</style>